/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-statements */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef, useEffect, useState } from 'react';
import {
	DndContext,
	closestCenter,
	MouseSensor,
	TouchSensor,
	DragOverlay,
	useSensor,
	useSensors
} from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	rectSortingStrategy,
	useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { globalEnv } from '../../../../config/baseConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMutation, useQuery } from 'react-query';
import {
	setSelectedSection,
	setTab
} from '../../../../redux/actions/sideBarAction';
import { hideSearchbarAction } from '../../../../redux/actions/searchBarAction';
import Scrollbars from 'react-custom-scrollbars-2';
import LoadingAnimComponent from '../../../Utils/LoadingAnimations/loadingAnimation';
import { DataNotFoundAnimation } from '../../../Utils/ErrorAnimations/dataNotFoundAnim';
import SaveButton from '../../../Utils/saveButton';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetUnsavedChangesAction } from '../../../../redux/actions/globalAction';
import axios from 'axios';
import LazyImage from '../../../Utils/Components/imageComponent';
import placeholder from '../../../../assets/images/placeholder.png';

export function EditImagesOrder() {
	const [activeId, setActiveId] = useState(null);
	const [compact, setCompact] = useState(false);
	const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

	async function fetchTopicDetails(id: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/topic/${id}/get-images`,
			config
		);
		return data;
	}

	const [dailyImageId, setDailyImageId] = useState('');

	const [images, setImages] = useState<any[]>([]);
	const [imagesClone, setImagesClone] = useState<any[]>([]);
	const [updatedImages, setUpdatedImages] = useState<any[]>([]);

	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const { topicId } = useParams();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	dispatch(setSelectedSection('Reorder topic images'));
	dispatch(setTab('documents'));
	dispatch(hideSearchbarAction());

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const navigate = useNavigate();

	const { data, isFetching, isLoading, isError } = useQuery(
		['images', topicId],
		() => fetchTopicDetails(topicId!),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	useQuery(
		['topicDailyImage', topicId],
		async () => {
			const config = {
				headers: { Authorization: 'Bearer ' + ACCESS_TOKEN }
			};
			const { data } = await axios.get(
				`${globalEnv.BASE_URL}/admin/topic/${topicId}/get-detailed?page=1&mediaType=images`,
				config
			);
			return data;
		},
		{
			refetchOnWindowFocus: false,
			staleTime: Infinity,
			onSuccess: (data) => {
				if (data?.data?.[0]?.dailyImage?._id)
					setDailyImageId(data.data[0].dailyImage._id);
			}
		}
	);

	useEffect(() => {
		const imagesCopy = images.slice();
		imagesCopy.forEach((image, index) => {
			if (image.index !== index) {
				console.log('old idnex', image.index, 'new index', index);
				imagesCopy[index] = { ...image, newIndex: index };
			}
		});
		setImagesClone(imagesCopy);
	}, [activeId]);

	useEffect(() => {
		const updatedImages = imagesClone.filter((image) => {
			if (image.newIndex != null)
				if (image.index !== image.newIndex) return image;
		});

		// Invert updatedImages indices
		const invertedImages: any[] = [];
		updatedImages.forEach((image) => {
			const oldIndex = imagesClone.length - 1 - image.index;
			const newIndex = imagesClone.length - 1 - image.newIndex;
			invertedImages.push({
				_id: image._id,
				index: oldIndex,
				newIndex: newIndex
			});
		});

		if (updatedImages.length > 0) setIsChanged(true);
		else setIsChanged(false);
		setUpdatedImages(invertedImages);
	}, [imagesClone]);

	useEffect(() => {
		if (data != null) {
			const images: any[] = [];
			data.forEach((image: any, index: number) => {
				if (data.index == null) image = { ...image, index: index };
				images.push(image);
			});
			setImages(images);
		}
	}, [data]);

	const saveTopicReq = async () => {
		const dto = {
			images: updatedImages
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.put(
			globalEnv.BASE_URL + `/admin/topic/${topicId}/reorder-images`,
			dto,
			config
		);
		return response;
	};

	const saveTopic = useMutation(saveTopicReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated topic info.'
				})
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				{isLoading ? (
					<LoadingAnimComponent />
				) : isError ? (
					<div className="h-full">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<div className="relative">
						<div className="fixed w-full pb-2 pr-24 flex flex-row z-30 bg-gray-200 dark:bg-gray-800 justify-end">
							<div>
								<button
									className={`btn btn-sm mr-1 mt-2 ${
										compact ? 'btn-primary' : 'btn-outline'
									}`}
									type="button"
									onClick={() => setCompact(!compact)}
								>
									{compact ? 'Normal View' : 'Compact View'}
								</button>
								<button
									className="btn btn-outline btn-sm mr-1 mt-2"
									type="button"
									style={{ transition: 'all .15s ease' }}
									onClick={() => navigate(`/home/topic/${topicId}`)}
								>
									Cancel
								</button>
								{isChanged && (
									<SaveButton
										isSaving={isSaving}
										saveFunc={() => saveTopic.mutate()}
									/>
								)}
							</div>
						</div>

						<div className="pt-6">
							<DndContext
								sensors={sensors}
								collisionDetection={closestCenter}
								onDragStart={handleDragStart}
								onDragEnd={handleDragEnd}
								onDragCancel={handleDragCancel}
							>
								<SortableContext items={images} strategy={rectSortingStrategy}>
									<Grid compact={compact}>
										{images.map((image: any, index: number) => (
											<SortablePhoto
												key={image._id}
												image={image}
												index={index}
												compact={compact}
												dailyImageId={dailyImageId}
											/>
										))}
									</Grid>
								</SortableContext>

								<DragOverlay adjustScale={true}>
									{activeId ? (
										<Photo
											image={activeId}
											index={images.indexOf(activeId)}
											compact={compact}
										/>
									) : null}
								</DragOverlay>
							</DndContext>
						</div>
					</div>
				)}
			</Scrollbars>
		</div>
	);

	function handleDragStart(event: any) {
		setActiveId(event.active.id);
	}

	function handleDragEnd(event: any) {
		const { active, over } = event;
		if (active.id !== over.id) {
			setImages((items: any[]) => {
				const oldIndex = items.indexOf(active.id);
				const newIndex = items.indexOf(over.id);

				return arrayMove(items, oldIndex, newIndex);
			});
		}

		setActiveId(null);
	}

	function handleDragCancel() {
		setActiveId(null);
	}
}

function Grid({ children, compact }: { children: any[]; compact?: boolean }) {
	return (
		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: compact ? 4 : 10,
				padding: 10
			}}
		>
			{children.map((child, i) => (
				<div key={child.key ?? i} style={{ width: compact ? 150 : 300 }}>
					{child}
				</div>
			))}
		</div>
	);
}

const SortablePhoto = (props: any) => {
	const sortable = useSortable({ id: props.image });
	const {
		attributes,
		listeners,
		isDragging,
		setNodeRef,
		transform,
		transition
	} = sortable;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition
	};

	return (
		<Photo
			ref={setNodeRef}
			style={style}
			isDragging={isDragging}
			compact={props.compact}
			{...props}
			{...attributes}
			{...listeners}
		/>
	);
};

const Photo = forwardRef(
	(
		{
			image,
			style,
			isDragging,
			compact,
			dailyImageId,
			...props
		}: {
			image: any;
			index: number;
			isDragging?: boolean;
			compact?: boolean;
			dailyImageId?: string;
			faded?: any;
			style?: any;
		},
		ref: any
	) => {
		const inlineStyles = {
			transformOrigin: '0 0',
			gridRowStart: null,
			gridColumnStart: null,
			opacity: isDragging ? 0 : 1,
			...style
		};

		return (
			<div
				ref={ref}
				style={inlineStyles}
				{...props}
				className={`flex flex-wrap flex-col w-full cursor-pointer ${
					compact ? 'p-1' : 'p-4'
				}`}
			>
				<div className="relative rounded-lg flex justify-center content-center w-full aspect-[16/10] dark:bg-gray-600 bg-gray-300 mb-1 group overflow-hidden">
					{dailyImageId && image._id === dailyImageId && (
						<span
							className={`absolute top-1 left-1 badge badge-success shadow-md z-10 ${
								compact ? 'badge-xs' : 'badge-sm'
							}`}
						>
							Daily
						</span>
					)}
					<LazyImage
						photo={image.url_low_res != null ? image.url_low_res : placeholder}
						style={
							'block object-cover object-center w-full h-full aspect-[16/10] rounded-lg'
						}
						dimesnions="100%"
						loaderDimesnions={compact ? 40 : 80}
					/>
				</div>
				{!compact && (
					<h3 className="mx-auto text-gray-700 dark:text-gray-200 font-semibold">
						{image.title}
					</h3>
				)}
			</div>
		);
	}
);

export default EditImagesOrder;
